/**
 * @author Fabrício Mendonça
 * 
 * @since 1.2.0
 * @since 18.10.2016
 */
namespace app.autenticacao {
    /** @ngInject */
    function config($httpProvider: ng.IHttpProvider) {
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push("AuthInterceptor");
    }
    /** @ngInject */
    function run(versionService: VersionService) {
        versionService.loadVersionUser();
    }
    angular
        .module("app.autenticacao", ["app.support"])
        .config(config)
        .run(run);
}